/**
 * Created by pzf on 2018/12/26
 *
 */
import LayoutInnerModal from './LayoutInnerModal';

export default LayoutInnerModal;